import React, { useState } from "react";
import { IconButton, Button, TextField, Modal, Box, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { SAVE_TRADES } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import { English } from "../../constant/EnglishFallback";

const RequestTradeModal = (props) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const [name, setName] = useState("");
  const [submit, setSubmit] = useState(false);

  const {
    TEXT_REQUEST_A_TRADE = English?.RequestTradeModal?.TEXT_REQUEST_A_TRADE,
    TEXT_TRADE = English?.RequestTradeModal?.TEXT_TRADE,
    BUTTON_CANCEL = English?.RequestTradeModal?.BUTTON_CANCEL,
    BUTTON_SUBMIT = English?.RequestTradeModal?.BUTTON_SUBMIT
  } = multiLanguageData?.RequestTradeModal || {};

  const handleClose = () => {
    setName("");
    setSubmit(false);
    props.onClose();
  };

  const onRequestSubmit = async () => {
    try {
      setSubmit(true);
      const formData = new FormData();
      formData.append("Id", 0);
      formData.append("Name", name);
      formData.append("TradePictureUrl", "");
      formData.append("Description", "");
      formData.append("ModifiedBy", 1);
      await Postrequestcall(SAVE_TRADES, formData, loginData?.accessToken, "formData");
      props?.setSnackbarOpen(true);
    } catch (error) {
      console.log("onRequestSubmit-> Error When Submitting Trade Request: ", error);
    } finally {
      handleClose();
    }
  };

  const onTradeChange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^([^A-Za-z0-9]{1,2})/, "");
    setName(inputValue);
  };

  return (
    <Modal open={props.open}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            pb: 1
          }}>
          <Typography variant="h6">{TEXT_REQUEST_A_TRADE}</Typography>
          <IconButton onClick={() => handleClose()}>
            <CloseIcon />
          </IconButton>
        </Box>

        <TextField
          label={TEXT_TRADE}
          name="description"
          variant="outlined"
          fullWidth
          value={name}
          onChange={onTradeChange}
        />

        <Box sx={{ pt: 1,  flexDirection: "row",  justifyContent: "flex-end",  display: "flex" }}   >
          <Button
            onClick={() => {
              !submit && onRequestSubmit();
            }}
            disabled={!name.trim()}
            color="primary"
            loading={submit}>
            {BUTTON_SUBMIT}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default RequestTradeModal;
